<mat-dialog-content>
  <h1 class="font-semibold text-2xl pb-3">
    Guardar pedido como borrador
  </h1>
  <div>
    <span>
      ¿Estás seguro que deseas guardar el pedido como borrador?
    </span>
  </div>
</mat-dialog-content>
<mat-dialog-actions class="gap-2 flex flex-row">
  <button class="rounded-3xl flex items-center gap-2 bg-gray-400 text-white py-2 px-4 cursor-pointer hover:bg-gray-600"
          (click)="close()">
    <span class="text-base">Cancelar</span>
    <i class="fi-rr-ban text-base flex"></i>
  </button>
  <button
    class="rounded-3xl flex items-center gap-2 bg-primary-300 text-white py-2 px-4 cursor-pointer hover:bg-primary-500 disabled:bg-orange-200 disabled:cursor-not-allowed"
    (click)="saveAsDraft()">
    <span class="text-base">Guardar</span>
    <i class="fi-rr-disk text-base flex"></i>
  </button>
</mat-dialog-actions>

